import styled from 'styled-components';

export const SocialLinks = styled.ul`
  li a {
    width: 56px;
    height: 56px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
`;

SocialLinks.displayName = 'SocialLinks';
